module.exports = __webpack_public_path__ + "media/images/backgrounds/texture-2021-light-01-2e092bd9e1addc862880e9f4ac5f490c.png";